import { action } from 'typesafe-actions';
import { v4 as uuid_v4 } from 'uuid';
import { ADD_ALERT, DISMISS_ALERT, DISMISS_ALERT_GROUP } from './constants';
import { AlertOptions } from '../../library/interfaces';
export const createAlert = (alertOptions: Partial<AlertOptions>) =>
  action(ADD_ALERT, { ...alertOptions, id: alertOptions.id || uuid_v4() } as AlertOptions);
export const dismissAlert = (id: string) => action(DISMISS_ALERT, { id });
export const dismissAlertGroup = (id: string) => action(DISMISS_ALERT_GROUP, { id });
